export type TNativeConvolverNode = ConvolverNode;
